import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import LeaderOrder from "./LeadrOrder";
import navOperations from 'redux/Navigation/operations';
import pendingOrderOperations from 'redux/PendingOrder/operations'
import RejectedBee from "../../../../../assets/images/PenndingApproval/Rejected Bee.png";
import userProfileSelectors from 'redux/UserProfile/selectors'
import selectors from "redux/Navigation/selectors";
import Moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import { CONSTANTS } from "client/utils/constants";
import { getFileName, popupInitialData } from "utils";
import { v1 as uuid } from "uuid";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { setAssetOrderDetailAttachments, setAssetOrderDetailLinkedAttachments, uploadAssetOrderDetailAttachments } from "Store/OrderManagement/BillOfSale/BillOfSaleAction";

const LeadrOrderContainer = (props?: any) => {
  const {
    ordertype
  } = props

  const activeRow = useSelector((state: any) => state.CustomerMyOrder.data)
  const { userDetails, headerNav, transferOrderByIdData, isOrderCanceled, actionPopupValue, afeOrderByIdData, docList, assetOrderDetailAttachments, assetOrderDetailLinkedAttachments }: any = useSelector((state: any) => ({
    userDetails: userProfileSelectors.getUserDetails(state),
    headerNav: selectors.GetHeaderNav(state),
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    isOrderCanceled: state.PendingOrder.isOrderCanceled,
    actionPopupValue: state.PendingOrder.actionPopupValue,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData,
    docList: state.UploadAttachmentsReducer.list,
    assetOrderDetailAttachments: state.BillOfSaleReducer.assetOrderDetailAttachments,
    assetOrderDetailLinkedAttachments: state.BillOfSaleReducer.assetOrderDetailLinkedAttachments
  }));

  const dispatch = useDispatch();
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchNav = navOperations.dispatchNav(dispatch)
  const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);
  const [headerNavItem, setHeaderNavItem] = useState("home");

  const [approvalAction, setApprovalAction] = useState<any>({
    actionby: "",
    cancelorderFailed: ""
  });
  const [documentList, setDocumentList] = useState<any>([]);
  const [attachmentError, setAttachmentError] = useState<string>("");
  const [updateOrderAttachments, setUpdateOrderAttachments] = useState<boolean>(false)

  const navigate = useNavigate();
  let { pagename } = useParams();

  const handleClickOrder = () => {
    if(ordertype === CONSTANTS.AFEREQUEST){
      navigate('/ordermanagement/assetcreateorder/' + afeOrderByIdData?.orderId + '/orderDetails' + '/' + CONSTANTS.AFEREQUEST);
    }else{
      navigate('/ordermanagement/assetcreateorder/' + transferOrderByIdData?.orderId + '/orderDetails' + '/' +transferOrderByIdData?.orderRequestType);
  }
    
    dispatch(RequisitionAction.setIsEditOrder(true))
    dispatch(RequisitionAction.setIsAddAssetclick(true))
  }

  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  const popupPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    cancelOrderRequest({ orderId: ordertype === CONSTANTS.AFEREQUEST ? afeOrderByIdData?.orderId : transferOrderByIdData?.orderId, savedBy: userDetails?.emailId, comments: comment });
    dispatchActionPopupValue({
      actionby: "CancelOrderBtn"
    })
    hideDialog();
  };

  const cancelOrderReq = (cancelOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      actionby: "CancelOrderBtn",
      href: "/ordermanagement",
      popupOutlinebtnOnclick: () => {
        hideDialog();
      }
    });
  };



  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const getPopupContent = (
    titleImg: string,
    actionby: string,
    subtextcontent: any,
    titleText: string,
    isCompletedReportVisible: any
  ) => {
    return {
      ...Popupcontent,
      titleImg,
      actionby,
      subtextcontent,
      title: titleText,
      isCompletedReportVisible,
      isDialogVisible: true,
      isTitleWarning: false,
      primaryBtnText: "",
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      outlineBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      primaryBtnnavigateTo: "",
      popupOutlinebtnOnclick: () => {
        if (actionPopupValue.actionby === "CancelOrderBtn") {
          dispatchActionPopupValue({})
          isOrderCanceled.approval = undefined;
          if(pagename === CONSTANTS.PAGE_NAME.ASSET){
            dispatchNav('Asset')
          }else{
            dispatchNav('Home')
          }
          navigate('/ordermanagement');
        }
        hideDialog();
      }
    };
  };

  const hideDialog = () => setPopupcontent({ ...Popupcontent, isDialogVisible: false });

  useEffect(() => {
    if (isOrderCanceled.approval) {
      dispatch(RequisitionAction.setIsChangesOccured(false))
      let cancelorder = "Order Cancelled Successfully"
      setApprovalAction({
        ...approvalAction,
        actionby: actionPopupValue.actionby,
        cancelorder
      });
    }
    else {
      let cancelorder = "Order Cancelled Failed"
      setApprovalAction({
        ...approvalAction,
        actionby: actionPopupValue.actionby,
        cancelorder
      });
    }
  }, [activeRow?.rowData, isOrderCanceled?.approval])

  useEffect(() => {
    if (approvalAction.actionby === "CancelOrderBtn") {
      setPopupcontent({
        ...getPopupContent(
          RejectedBee,
          "Order Cancelled Successfully",
          "Order Cancelled Successfully",
          "Success",
          false
        ),
      });
    }
  }, [approvalAction]);

  useEffect(() => {
    if(transferOrderByIdData?.orderAttachments?.length > 0){
      dispatch(setAssetOrderDetailAttachments((transferOrderByIdData?.orderAttachments)))
      let alreadyLinkedattacment: any = []
      transferOrderByIdData?.transferDisposeReactivationDetails?.map((request: any, index: any) => {
        request?.assets?.map((itemLevel: any) => {
          let objAttachments: any = {}
          objAttachments.fleetItemId = itemLevel?.transferDispoReactivationAssetDetailId
          objAttachments.attachments = itemLevel?.assetAttachments
          alreadyLinkedattacment.push(objAttachments)
        })
      })
      dispatch(setAssetOrderDetailLinkedAttachments(alreadyLinkedattacment))
    }
  }, [transferOrderByIdData])

  useEffect(() => {
    if(transferOrderByIdData?.orderId && updateOrderAttachments){
        let payload = {
            orderId: transferOrderByIdData?.orderId,
            attachments: docList,
            savedBy: userDetails?.emailId
        }
        dispatch(uploadAssetOrderDetailAttachments(payload))
        setUpdateOrderAttachments(false)
    }
    dispatch(setAssetOrderDetailAttachments(docList));
  }, [docList]);

  const createdDateval = () => {
  if (ordertype === CONSTANTS.AFEREQUEST && afeOrderByIdData?.createdDate) {
    return Moment(afeOrderByIdData.createdDate).format('MM/DD/YYYY');
  }
  if (transferOrderByIdData?.createdDate) {
    return Moment(transferOrderByIdData.createdDate).format('MM/DD/YYYY');
  }
  if (transferOrderByIdData?.orderDate) {
    return Moment(transferOrderByIdData.orderDate).format('MM/DD/YYYY');
  }
  return '';
};

  const requestDetails =  transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => detailsByIdItem).pop() ?? {}

  const createdRequestTypeVal = () => {
    if(requestDetails?.orderRequestType){
      return requestDetails?.orderRequestType == CONSTANTS?.TRANSFER_REQUEST ? CONSTANTS.TRANSFER : requestDetails?.orderRequestType === CONSTANTS?.DISPOSITION_REQUEST ? CONSTANTS.DISPOSITION : CONSTANTS.REACTIVATION
    }else{
      return ""
    }
  }



  const isUploaded = (name: string) => assetOrderDetailAttachments.find((x: any) => getFileName(x.attachmentUrl) === name);
  const onUploadClick = (fileList: Array<File>) => {
      setAttachmentError("");
      const filteredList = [
          ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
      ];
      if (filteredList.length > 0 && filteredList.length <= 5) {
          setAttachmentError("");
          let totalSize = 0;
          filteredList.forEach((file: File) => {
              totalSize = totalSize + (file.size || 0);
          });
          if (totalSize <= 5000000) {
              setAttachmentError("");
              const formData = new FormData();
              formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

              for (let i = 0; i < filteredList.length; i++) {
                  formData.append("Files", filteredList[i] as any);
              }
              UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch)({ formData, filteredList, list: assetOrderDetailAttachments });
              setUpdateOrderAttachments(true)
          } else {
              setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
          }
      } else if (fileList.length > 5) {
          setAttachmentError(
              "Please Upload files without exceeding maximum limit of 5 files"
          );
      } else {
          if (fileList.length > 0 && !filteredList.length) {
              setAttachmentError("All files are uploaded try to add new files");
          } else {
              setAttachmentError("Choose at least 1 file to upload");
          }
      }
  };

  const onRemoveAttachment = (index: any) => {
    const findattachment = assetOrderDetailAttachments?.find((_attachment: any, i: any) => index === i);
    const assetArr = [];
    if (findattachment) {
        for (let i = 0; i < assetOrderDetailLinkedAttachments?.length; i++) {
          assetOrderDetailLinkedAttachments[i]?.attachments?.forEach((assetVal: any) => {
                const findAttch = (assetVal?.fileName === findattachment?.fileName);
                if (findAttch) {
                    assetArr.push(assetVal)
                }
            })
        }
    }
    if (assetArr?.length) {
        setAttachmentError("The attachment file cannot be deleted. File linked to the item.");
    }
    else {
        const newArr = assetOrderDetailAttachments.slice();
        newArr.splice(index, 1);
        const newFileList = [...documentList];
        newFileList.splice(index, 1);
        setDocumentList(newFileList);
        UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch)(newArr);
        setAttachmentError("");
        setUpdateOrderAttachments(true)
    }
  }

  const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  return (
    <LeaderOrder
      transferOrderByIdData={ordertype === CONSTANTS.AFEREQUEST ? afeOrderByIdData : transferOrderByIdData }
      handleClickOrder={handleClickOrder}
      cancelOrderReq={cancelOrderReq}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      createdDateval={createdDateval}
      userDetails={userDetails}
      createdRequestTypeVal = {createdRequestTypeVal}
      popupPrimarybtnOnclick = {popupPrimarybtnOnclick}
      ordertype = {ordertype}
      assetOrderDetailAttachments={assetOrderDetailAttachments}
      setDocumentList={setDocumentList}
      documentList={documentList}
      setAttachmentError={setAttachmentError}
      attachmentError={attachmentError}
      onUploadClick={onUploadClick}
      onRemoveAttachment={onRemoveAttachment}
      getUserRoles={getUserRoles}
    />
  )
}

export default LeadrOrderContainer;